'use client';

import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useSite } from '@salesforce/storefront-next-runtime/site-context';
import { EmbeddedComponentRegion } from '@/components/region/embedded-component-region';
import type { ComponentWithComponentData } from '@/lib/page-designer/component-loader.server';
import { GLOBAL_HEADER_APP_BANNER_REGION_ID } from '@/extensions/snk/constants';
import { isUkShopper } from '../../../lib/is-uk-shopper';
import { AppBannerContext } from './app-banner-context';
import type { WalletProvider } from '@/extensions/snk/lib/device-utils';

type MobileAppBannerProps = {
    /** Host component holding the `appBanner` region. */
    headerBanner?: Promise<ComponentWithComponentData | null>;
    platform?: WalletProvider;
};

/** App download prompt: UK only, content authored in BM. Dismissal persists for the session. */
export const MobileAppBanner = ({ headerBanner, platform }: MobileAppBannerProps): ReactElement | null => {
    const { locale } = useSite();
    const { t } = useTranslation('app');

    if (!isUkShopper(locale?.id) || !headerBanner) {
        return null;
    }

    return (
        <AppBannerContext.Provider value={platform}>
            <aside data-slot="mobile-app-banner-region" aria-label={t('regionLabel')}>
                <EmbeddedComponentRegion
                    component={headerBanner}
                    regionId={GLOBAL_HEADER_APP_BANNER_REGION_ID}
                    fallbackElement={null}
                    errorElement={null}
                />
            </aside>
        </AppBannerContext.Provider>
    );
};
